import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

import { ROUTES } from 'constants/routes';
import { formPropType } from 'redux/userFormHandlers';
import WithoutAccounts from 'app/components/WithoutAccounts';
import { gaTrackPageView } from 'services/AnalyticsService';

import NewComplaintScene from './layout';

class NewComplaintSceneContainer extends PureComponent {
  componentDidMount() {
    if (!(!this.props.loading && !this.props.complaintForm)) gaTrackPageView(this.props.location.pathname);
  }

  componentDidUpdate() {
    if (!(!this.props.loading && !this.props.complaintForm)) gaTrackPageView(this.props.location.pathname);
  }

  render() {
    if (!this.props.loading && !this.props.complaintForm) {
      return <Redirect to={ROUTES.COMPLAINTS} />;
    }
    return (
      <NewComplaintScene
        loading={this.props.loading}
        complaintForm={this.props.complaintForm}
        isPublic={this.props.location.pathname === ROUTES.PUBLIC_NEW_COMPLAINT}
      />
    );
  }
}

NewComplaintSceneContainer.propTypes = {
  complaintForm: formPropType,
  loading: PropTypes.bool.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired
  })
};

const mapStateToProps = store => ({
  complaintForm: store.utility.complaintForm,
  loading: store.utility.complaintFormLoading,
  accounts: store.account.accounts,
  accountsLoading: store.account.accountsLoading
});

export default connect(mapStateToProps)(
  WithoutAccounts({
    shouldShowMessage: props => props.accounts.length === 0 && !props.accountsLoading,
    accountsError: props => props.accountsError
  })(NewComplaintSceneContainer)
);
